import { render, staticRenderFns } from "./DeliveryStatusRow.vue?vue&type=template&id=08493f54&scoped=true"
import script from "./DeliveryStatusRow.vue?vue&type=script&lang=ts"
export * from "./DeliveryStatusRow.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryStatusRow.vue?vue&type=style&index=0&id=08493f54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08493f54",
  null
  
)

export default component.exports